var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStepperActive = function SvgIconStepperActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F4440",
    d: "m6.818 11.545 5.602-5.603-.878-.878L6.818 9.79 4.443 7.414l-.878.878zm1.184 4.372a7.7 7.7 0 0 1-3.088-.624A8 8 0 0 1 2.4 13.602a8 8 0 0 1-1.692-2.514 7.7 7.7 0 0 1-.624-3.086q0-1.644.623-3.088A8 8 0 0 1 2.4 2.4 8 8 0 0 1 4.912.707 7.7 7.7 0 0 1 8 .083q1.642 0 3.088.624 1.444.623 2.514 1.692a8 8 0 0 1 1.693 2.513q.623 1.445.623 3.087a7.7 7.7 0 0 1-.623 3.087 8 8 0 0 1-1.692 2.515 8 8 0 0 1-2.513 1.692 7.7 7.7 0 0 1-3.087.624"
  })));
};
export default SvgIconStepperActive;